import React, { useRef, useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Avatar,
  Typography,
  Chip,
  Button,
  Paper,
  Tabs,
  Tab,
  useMediaQuery,
  Link,
  Breadcrumbs,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PerformanceGauge from '../Member-Profile-Edit/PerformanceGauge';
import BillingSettingsTabsContent from '../../components/BillingSettings/BillingSettingsTabsContent';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useLocation } from 'react-router-dom';
const menuItems = [
  'INFORMATION',
  'BILLING HISTORY',
];

const BillingSettings = () => {
  const [activeTab, setActiveTab] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const tabRefs = useRef(menuItems.map(() => React.createRef()));

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    if (isMobile && tabRefs.current[activeTab]?.current) {
      tabRefs.current[activeTab].current.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    }
  }, [activeTab, isMobile]);


  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabFromURL = params.get("tab");

    if (tabFromURL !== null) {
      setActiveTab(parseInt(tabFromURL));
      window.scrollTo(0, 0);    // PAGE TOP
    }
  }, [location]);
  return (
    <Box p={2}>

      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
        <Link underline="hover" color="inherit" href="/all-settings" sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: '#1A1F36' }}>
          <ArrowBackIosIcon sx={{ fontSize: '16px', color: '#1760EC', }} /> Settings
        </Link>
      </Breadcrumbs>

      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, }}>
        <Box className="card-body bg-base border rounded-3 overflow-hidden h-100" sx={{ display: 'flex', alignItems: 'center', width: '100%', padding: '14px 16px' }}>
          <Typography sx={{ fontSize: '19px', fontWeight: '700', color: '#1A1F36', fontFamily: 'Manrope' }}>
            Billing Settings
          </Typography>
        </Box>
      </Box>


      <Box
        sx={{
          display: 'flex',
          justifyContent: 'between',
          alignItems: 'start',
          gap: 2,
          marginTop: '24px',
          flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap', xs: 'wrap' }
        }}
      >
        {/* Tabs (Left Side) */}
        <Box sx={{
          minWidth: { xl: '320px', lg: '210px', md: '250px', sm: '100%', xs: '100%' },
          maxWidth: { xl: '320px', lg: '210px', md: '250px', sm: '100%', xs: '100%' },
          position: 'sticky',
          top: '100px',
        }}
          className="card-body bg-base border rounded-3 overflow-hidden">
          <Paper
            elevation={1}
            sx={{
              boxShadow: 'none',
              padding: 0,
              ...(isMobile
                ? { mb: 2, overflowX: 'auto' }
                : { height: '100%', minHeight: { xl: '400px', lg: '400px', md: '400px', sm: '100%', xs: '100%' } }),
            }}
          >
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              orientation={isMobile ? 'horizontal' : 'vertical'}
              variant="scrollable"
              scrollButtons={isMobile ? 'auto' : false}
              allowScrollButtonsMobile
              sx={{
                borderColor: 'divider',
                p: 0,
                '& .MuiTabs-list': {

                  flexDirection: { xl: 'column', lg: 'column', md: 'column', sm: 'row', xs: 'row' },
                  overflowX: 'auto'
                },
                '& .MuiButtonBase-root': {
                  justifyContent: 'start',
                  textAlign: 'left'
                },
                '& .MuiTabs-indicator': {
                  backgroundColor: { xl: '#1976d2', lg: '#1976d2', md: '#1976d2', sm: '#fff', xs: '#fff' }
                }
              }}
            >
              {menuItems.map((item, index) => (
                <Tab
                  key={item}
                  label={item}
                  ref={tabRefs.current[index]}
                  sx={{
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: 14,
                    alignItems: isMobile ? 'center' : 'flex-start',
                    flexDirection: 'row'
                  }}
                />
              ))}
            </Tabs>
          </Paper>
        </Box>

        {/* Tab Content (Right Side) */}
        <Box sx={{ flexGrow: 1 }} className="card-body bg-base border rounded-3 w-100 overflow-hidden">
          <Paper
            elevation={1}
            sx={{ padding: { xl: '24px', lg: '18px', md: '12px', sm: '24px', xs: '24px' }, borderRadius: 0, boxShadow: 'none', border: 'none', }}
          >
            <BillingSettingsTabsContent activeTab={activeTab} menuItems={menuItems} />
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default BillingSettings;
